/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Modal,
  Icon,
  Table,
  Ref,
  Checkbox,
  Input,
  Portal,
  ModalDescription,
  TextArea,
  Loader,
  Dropdown,
  Header,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import dragbarImg from '../../images/components/my/drager.svg';
import ResultRenderer from '../ResultRenderer/ResultRenderer';
import WithRouter from '../Extensions/WithRouter';
import EditCveCodeModal from './EditCveCodeModal';

class EditComponentModal extends Component {
  constructor(props) {
    super(props);
    this.typingTimeout = null;
    this.lastEdit = null;
    this.modalRef = React.createRef();
    this.resultsRef = React.createRef();
    this.state = {
      isChange: false,
      componentList: props.componentList,
      sumData: props.sumData,
      activeIndex: '',
      currentId: '',
      errorIndex: [],
      selectedRowIds: [],
      resultList: [],
      revertList: [],
      selectedResultData: {},
      cveList: [],
      errorMessage: '',
      limit: 25,
      isOpenCVE: false,
      currentCVEIndex: '',
      allSelected: false,
      titleLicenseLoadingIndex: [],
      securitiesLoadingIndex: [],
      homepageLoadingIndex: [],
      target: 'all',
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMEC, componentList, sumData } = this.props;

    if (isOpenMEC !== prevProps.isOpenMEC || sumData !== prevProps.sumData) {
      this.setState({
        isChange: false,
        errorMessage: '',
        errorIndex: [],
        isOpenCVE: false,
        cveList: [],
        titleLicenseLoadingIndex: [],
        homepageLoadingIndex: [],
        securitiesLoadingIndex: [],
        revertList: JSON.parse(JSON.stringify(componentList)),
        componentList,
        sumData,
        isAppliyNextScan: sumData.is_applied,
        coverage: sumData.coverage,
        comment: sumData.comment,
        target: sumData.component_version || 'all',
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.typingTimeout);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleMouseOver = (event) => {
    const target = event.currentTarget;
    const { font } = window.getComputedStyle(target); //get font

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font;
    const textWidth = context.measureText(target.value).width; //measure text width

    if (target.clientWidth - 28 < textWidth && !target.getAttribute('title')) {
      target.setAttribute('title', target.value);
    } else if (target.clientWidth - 28 >= textWidth) {
      target.removeAttribute('title');
    }
  };

  handleClickOutside = (event) => {
    const { activeIndex } = this.state;
    if (activeIndex === '') {
      return;
    }

    if (
      this.resultsRef.current && this.resultsRef.current.contains(event.target)
    ) {
      return;
    }
    this.setState({ activeIndex: '' });
  };

  handleSave = () => {
    let req;
    const { componentList, sumData, target } = this.state;
    const {
      translate, handleModalLoader, handleSaveCallback, state
    } = this.props;

    const components = componentList.map((item) => {
      return {
        component_name: item.component_name,
        component_version: item.component_version,
        homepage: item.homepage,
        title_license: item.title_license,
        securities: item.securities,
      };
    });

    if (state.user.currentPrecisionLevel) {
      req = {
        components,
        is_applied: sumData.is_applied,
        precision_level: state.user.currentPrecisionLevel,
      };
    } else {
      req = {
        components,
        is_applied: sumData.is_applied,
      };
    }

    req.component_name = sumData.component_name;
    req.component_version = target === 'all' ? '' : target;

    if (req.is_applied) {
      req.coverage = sumData.coverage;
      req.comment = sumData.comment;
    }

    const validateObj = componentList.map((item) => {
      return this.validateForm(item);
    });

    if (validateObj.indexOf(false) > -1) {
      return;
    }

    handleModalLoader(true);

    api
      .updateOrSaveComponent(
        req,
        sumData.uploaded_file_id,
        sumData.scanned_file_id
      )
      .then(() => {
        handleModalLoader(false);
        handleSaveCallback(sumData);
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        handleModalLoader(false);

        if (o.error === '422-671') {
          return this.setState({
            errorMessage: translate('modal.message.required_component_name'),
          });
        }
        if (o.error === '422-674') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_component_name'),
          });
        }
        if (o.error === '422-675') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_component_version'),
          });
        }
        if (o.error === '422-676') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_title_license'),
          });
        }
        if (o.error === '422-677') {
          return this.setState({
            errorMessage: translate('modal.message.required_is_apply'),
          });
        }

        if (o.error === '422-679') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_security'),
          });
        }

        if (o.error === '422-680') {
          return this.setState({
            errorMessage: translate('modal.message.required_title_license'),
          });
        }

        if (o.error === '422-692') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_coverage'),
          });
        }

        if (o.error === '422-681') {
          return this.setState({
            errorMessage: translate(
              'modal.message.duplicate_component_version'
            ),
          });
        }

        if (o.error_description) {
          this.setState({
            errorMessage: o.error_description,
          });
        } else {
          this.setState({
            errorMessage: translate('modal.error.unknow_error'),
          });
        }
      });
  };

  handleSaveBySetting = () => {
    const { componentList, sumData } = this.state;
    const { translate, handleModalLoader, handleSaveCallback } = this.props;

    const components = componentList.map((item) => {
      return {
        component_name: item.component_name,
        component_version: item.component_version,
        title_license: item.title_license,
        homepage: item.homepage,
        securities: item.securities,
      };
    });

    const req = {
      user_defined_id: sumData.user_defined_id,
      coverage: sumData.coverage,
      comment: sumData.comment,
      components,
    };

    const validateObj = componentList.map((item) => {
      return this.validateForm(item);
    });

    if (validateObj.indexOf(false) > -1) {
      return;
    }

    handleModalLoader(true);

    api
      .updateCustomerCompanyDefinedResult(req)
      .then(() => {
        handleModalLoader(false);
        handleSaveCallback();
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        handleModalLoader(false);

        if (o.error === '422-671') {
          return this.setState({
            errorMessage: translate('modal.message.required_component_name'),
          });
        }
        if (o.error === '422-674') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_component_name'),
          });
        }
        if (o.error === '422-675') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_component_version'),
          });
        }
        if (o.error === '422-676') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_title_license'),
          });
        }
        if (o.error === '422-677') {
          return this.setState({
            errorMessage: translate('modal.message.required_is_apply'),
          });
        }

        if (o.error === '422-679') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_security'),
          });
        }

        if (o.error === '422-680') {
          return this.setState({
            errorMessage: translate('modal.message.required_title_license'),
          });
        }

        if (o.error === '422-692') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_coverage'),
          });
        }

        if (o.error === '422-681') {
          return this.setState({
            errorMessage: translate(
              'modal.message.duplicate_component_version'
            ),
          });
        }

        if (o.error_description) {
          this.setState({
            errorMessage: o.error_description,
          });
        } else {
          this.setState({
            errorMessage: translate('modal.error.unknow_error'),
          });
        }
      });
  };

  handleCheckAllChange = () => {
    const { componentList, allSelected } = this.state;
    if (allSelected) {
      return this.setState({
        selectedRowIds: [],
        allSelected: false,
      });
    }
    const newState = componentList.map((item) => {
      return item.id;
    });

    this.setState({
      selectedRowIds: newState,
      allSelected: true,
    });
  };

  handleCheckChange = (e, { value }) => {
    const { selectedRowIds } = this.state;
    let newState;

    if (selectedRowIds.indexOf(value) > -1) {
      newState = selectedRowIds.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...selectedRowIds, value];
    }

    this.setState({
      selectedRowIds: newState,
    });
  };

  handleDeleteRow = () => {
    const { selectedRowIds, componentList } = this.state;
    const newState = componentList.filter((item) => {
      return selectedRowIds.indexOf(item.id) === -1;
    });

    this.setState(
      {
        componentList: newState,
        selectedRowIds: [],
      },
      () => {
        this.changeValidation();
      }
    );
  };

  handleAddRow = () => {
    const { componentList } = this.state;
    const customIds = [];

    const existIds = componentList.map((item) => {
      return item.id;
    });

    while (customIds.length < 1) {
      const r = uuidv4();
      if (existIds.indexOf(r) === -1) {
        customIds.push(r);
      }
    }

    const newData = {
      component_name: '',
      component_version: '',
      title_license: '',
      securities: [],
      id: customIds[0],
    };

    this.setState(
      {
        componentList: Update(componentList, {
          $unshift: [newData],
        }),
      },
      () => {
        this.changeValidation();
      }
    );
  };

  handleChange = (id, dataType, value) => {
    const { componentList } = this.state;
    let processedValue;

    if (dataType === 'component_name' || dataType === 'component_version') {
      processedValue = value.toLowerCase().replace(/\s/g, '');
    } else if (dataType === 'title_license') {
      processedValue = value.replace(/\s/g, '');
    } else {
      processedValue = value;
    }

    if (
      value.length !== 0 && dataType !== 'title_license' && dataType !== 'homepage'
    ) {
      if (!this.textValidation(dataType, value)) {
        return;
      }
    }

    const newData = componentList.map((item) => {
      if (item.id !== id) {
        return item;
      }
      return {
        ...item,
        [dataType]: processedValue,
      };
    });

    this.setState({
      componentList: newData,
      resultList: [],
      activeIndex: '',
      currentId: id,
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      const edtingindex = componentList.findIndex((item) => {
        return item.id === id;
      });

      if (processedValue === '' && dataType !== 'component_version') {
        this.setState({ resultList: [], activeIndex: '' });
        return;
      }

      if (dataType === 'component_name') {
        this.searchComponentName(processedValue, dataType);
      } else if (dataType === 'component_version') {
        this.searchComponentVersion(
          processedValue,
          dataType,
          componentList[edtingindex].component_name
        );
      } else if (dataType === 'title_license') {
        this.searchComponentLicense(processedValue, dataType);
      } else if (dataType === 'homepage') {
        this.searchHomepage(processedValue, dataType);
      }
    }, 1000);
  };

  handleFocus = (id, dataType, value) => {
    const { componentList } = this.state;

    const edtingindex = componentList.findIndex((item) => item.id === id);

    this.lastEdit = {
      id,
      dataType,
      processedValue: componentList[edtingindex]?.[dataType],
    };

    const performSearch = (searchKeyword) => {
      this.setState(
        {
          currentId: id,
          selectedResultData: {},
          activeIndex: '',
          resultList: [],
        },
        () => {
          const componentName = componentList[edtingindex]?.component_name;

          if (dataType === 'component_name') {
            this.searchComponentName(searchKeyword, dataType);
          } else if (dataType === 'component_version') {
            this.searchComponentVersion(searchKeyword, dataType, componentName);
          } else if (dataType === 'title_license') {
            this.searchComponentLicense(searchKeyword, dataType);
          } else if (dataType === 'homepage') {
            this.searchHomepage(searchKeyword, dataType);
          }
        }
      );
    };
    performSearch(value);
  };

  handleBlurOnName = (id) => {
    const {
      componentList, selectedResultData, revertList, resultList
    } = this.state;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    const editingIndex = componentList.findIndex((item) => {
      return item.id === id;
    });
    const revertIndex = revertList.findIndex((item) => {
      return item.id === id;
    });
    const initialObject = revertList[revertIndex];

    if (!initialObject) {
      return this.updateStateAndValidation(id, {
        currentId: id,
        activeIndex: '',
      });
    }

    if (!selectedResultData || Object.keys(selectedResultData).length === 0) {
      const componentName = componentList[editingIndex].component_name;

      if (!componentName) {
        return this.updateStateAndValidation(id, {
          currentId: id,
          activeIndex: '',
          componentList: this.updateComponentName(
            componentList,
            editingIndex,
            initialObject.component_name
          ),
        });
      }

      const checkUnknownName = resultList.find((item) => {
        return item.name === componentName && item.id === 'exact';
      });
      if (checkUnknownName) {
        return this.updateStateAndValidation(id, {
          currentId: id,
          activeIndex: '',
          componentList: this.updateComponentListFields(
            componentList,
            editingIndex,
            initialObject.component_name
          ),
        });
      }

      const checkPreName = revertList.find((item) => {
        return item.component_name === componentName;
      });
      if (checkPreName) {
        return this.updateStateAndValidation(id, {
          currentId: id,
          activeIndex: '',
        });
      }

      return this.updateStateAndValidation(id, {
        currentId: id,
        activeIndex: '',
        componentList: this.resetComponentFields(componentList, editingIndex),
      });
    }

    if (initialObject.component_name === selectedResultData.name) {
      return this.updateStateAndValidation(id, {
        currentId: id,
        activeIndex: '',
        selectedResultData: {},
      });
    }

    return this.updateStateAndValidation(id, {
      currentId: id,
      activeIndex: '',
      componentList: this.resetComponentFields(componentList, editingIndex),
      revertList: this.resetComponentFields(revertList, revertIndex),
      selectedResultData: {},
    });
  };

  handleBlurOnVersion = (id) => {
    const { componentList, selectedResultData, revertList } = this.state;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    const editingIndex = componentList.findIndex((item) => {
      return item.id === id;
    });
    const revertIndex = revertList.findIndex((item) => {
      return item.id === id;
    });
    const initialObject = revertList[revertIndex];

    if (!initialObject) {
      return this.setState(
        {
          currentId: id,
          activeIndex: '',
        },
        () => {
          this.changeValidation(id);
        }
      );
    }

    const currentComponent = componentList[editingIndex];
    const inputValue = currentComponent.component_version.trim();

    if (
      Object.keys(selectedResultData).length === 0 && selectedResultData.constructor === Object && inputValue === ''
    ) {
      return this.setState(
        {
          currentId: id,
          activeIndex: '',
          componentList: Update(componentList, {
            [editingIndex]: {
              component_version: { $set: initialObject.component_version },
            },
          }),
        },
        () => {
          this.changeValidation(id);
        }
      );
    }

    if (
      Object.keys(selectedResultData).length === 0 && selectedResultData.constructor === Object
    ) {
      const { component_name, component_version } = currentComponent;
      if (component_name && component_version) {
        this.updateAllComponentData(
          componentList,
          component_name,
          component_version,
          id
        );
      }
    }

    return this.setState(
      {
        currentId: id,
        activeIndex: '',
      },
      () => {
        this.changeValidation(id);
      }
    );
  };

  handleBlurOnLicense = (id) => {
    const {
      componentList, selectedResultData, revertList, resultList
    } = this.state;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    const editingIndex = componentList.findIndex((item) => {
      return item.id === id;
    });
    const revertIndex = revertList.findIndex((item) => {
      return item.id === id;
    });
    const initialObject = revertList[revertIndex];
    const unknownLicense = resultList.filter((item) => {
      return item.name === componentList[editingIndex].title_license;
    });

    if (!initialObject) {
      return this.setState(
        {
          currentId: id,
          activeIndex: '',
        },
        () => {
          this.changeValidation(id);
        }
      );
    }

    if (
      Object.keys(selectedResultData).length === 0 && selectedResultData.constructor === Object
    ) {
      if (
        componentList[editingIndex].title_license === '' || (unknownLicense.length !== 0 && unknownLicense[0].id === 'exact')
      ) {
        return this.setState(
          {
            currentId: id,
            activeIndex: '',
            componentList: Update(componentList, {
              [editingIndex]: {
                title_license: { $set: initialObject.title_license },
              },
            }),
          },
          () => {
            this.changeValidation(id);
          }
        );
      }
      return this.setState(
        {
          currentId: id,
          activeIndex: '',
        },
        () => {
          this.changeValidation(id);
        }
      );
    }

    return this.setState(
      {
        currentId: id,
        activeIndex: '',
      },
      () => {
        this.changeValidation(id);
      }
    );
  };

  handleBlurOnHomepage = (id) => {
    const { componentList, selectedResultData, revertList } = this.state;

    const editingIndex = componentList.findIndex((item) => {
      return item.id === id;
    });
    const revertIndex = revertList.findIndex((item) => {
      return item.id === id;
    });
    const initialObject = revertList[revertIndex];

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    if (!initialObject) {
      return this.setState(
        {
          currentId: id,
          activeIndex: '',
        },
        () => {
          this.changeValidation(id);
        }
      );
    }
    if (
      Object.keys(selectedResultData).length === 0 && selectedResultData.constructor === Object
    ) {
      if (
        componentList[editingIndex].homepage === '' && initialObject.homepage !== ''
      ) {
        return this.setState(
          {
            currentId: id,
            activeIndex: '',
            componentList: Update(componentList, {
              [editingIndex]: {
                homepage: { $set: initialObject.homepage },
              },
            }),
          },
          () => {
            this.changeValidation(id);
          }
        );
      }
    }
    return this.setState(
      {
        currentId: id,
        activeIndex: '',
      },
      () => {
        this.changeValidation(id);
      }
    );
  };

  handleApplyNextScanChange = () => {
    const { sumData } = this.state;
    this.setState(
      (prevState) => {
        const newData = !sumData.is_applied;
        return {
          sumData: {
            ...prevState.sumData,
            is_applied: newData,
          },
        };
      },
      () => {
        this.changeValidation();
      }
    );
  };

  handleResultSelect = async (e, result) => {
    const { currentId, componentList } = this.state;
    const currentIndex = componentList.findIndex((item) => {
      return item.id === currentId;
    });
    const updatedComponentList = [...componentList];

    if (
      this.lastEdit && this.lastEdit.id === currentId && this.lastEdit.dataType === result.data_type
    ) {
      if (result.name === this.lastEdit.processedValue) {
        return false;
      }
    }

    updatedComponentList[currentIndex][result.data_type] = result.name;

    this.setState({
      componentList: updatedComponentList,
      activeIndex: '',
      selectedResultData: result,
      currentId: '',
    });

    if (result.data_type === 'component_version') {
      const { component_name } = updatedComponentList[currentIndex];
      const component_version = result.name;

      await this.updateAllComponentData(
        updatedComponentList,
        component_name,
        component_version,
        currentId
      );
    }
  };

  handleCVEModalChange = (row, index) => {
    this.setState({
      isOpenCVE: true,
      cveList: row,
      currentCVEIndex: index,
    });
  };

  handleCVEDataChange = (rowData) => {
    const { currentCVEIndex, componentList } = this.state;

    const newData = rowData.map((item) => {
      return {
        code: item.code,
        risk: item.risk,
      };
    });

    const updatedComponentList = componentList.map((component, index) => {
      if (index === currentCVEIndex) {
        return {
          ...component,
          securities: newData,
        };
      }
      return component;
    });

    this.setState({
      componentList: updatedComponentList,
      currentCVEIndex: '',
      isChange: true,
    });
  };

  handleOptionChange = (e, { value }) => {
    const { sumData } = this.state;

    if (sumData.coverage === value) {
      return;
    }

    const newSumData = {
      ...sumData,
      coverage: value,
    };

    this.setState({
      sumData: newSumData,
      isChange: true,
    });
  };

  handleTargetOptionChange = (e, { value }) => {
    const { target } = this.state;
    if (target === value) {
      return;
    }

    this.setState({
      target: value,
      isChange: true,
    });
    this.getComponentEdit(value);
  };

  handleTextAreaChange = (e, { value }) => {
    const { sumData } = this.state;
    const newSumData = { ...sumData };

    newSumData.comment = value;

    this.setState({
      sumData: newSumData,
      isChange: true,
    });
  };

  getComponentEdit = (value) => {
    const { sumData } = this.state;
    const { state } = this.props;
    let type;
    if (state.user.currentPrecisionLevel) {
      type = state.user.currentPrecisionLevel;
    } else {
      type = null;
    }

    const uid = sumData.uploaded_file_id;

    const obj = {
      component_name: sumData.component_name,
      component_version: value === 'all' ? '' : value,
      precision_level: type,
    };

    api
      .getComponentEdit(uid, obj)
      .then((response) => {
        const data = response.response;
        const customIds = [];
        while (customIds.length < data.components.length) {
          const r = uuidv4();
          customIds.push(r);
        }

        const componentList = data.components.map((row, index) => {
          return {
            id: customIds[index],
            component_name: row.component_name,
            component_version: row.component_version,
            securities: row.securities,
            title_license: row.title_license,
          };
        });

        this.setState({
          componentList,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  updateAllComponentData = async (
    componentList,
    component_name,
    component_version,
    currentId
  ) => {
    const currentIndex = componentList.findIndex((item) => {
      return item.id === currentId;
    });
    if (currentIndex === -1) return;

    const updatedComponentList = [...componentList];

    this.setState((prevState) => {
      return {
        titleLicenseLoadingIndex: [
          ...prevState.titleLicenseLoadingIndex,
          `title_license_${currentId}`,
        ],
        securitiesLoadingIndex: [
          ...prevState.securitiesLoadingIndex,
          `securities_${currentId}`,
        ],
        homepageLoadingIndex: [
          ...prevState.homepageLoadingIndex,
          `homepage_${currentId}`,
        ],
      };
    });

    try {
      const [licenseResponse, securityResponse, homepageResponse] = await Promise.all([
        this.searchComponentLicenses(
          component_name,
          component_version,
          currentId
        ),
        this.searchComponentSecurities(
          component_name,
          component_version,
          currentId
        ),
        this.buildHomepageFromComponent(component_name, currentId),
      ]);

      const licenseData = licenseResponse.response;
      if (Object.keys(licenseData[0].license).length === 0) {
        //fallback
        const checkedLicenseResponse = await this.searchComponentLicenses(
          component_name,
          '',
          currentId
        );
        const checkedData = checkedLicenseResponse.response;
        const index = checkedData.findIndex((item) => {
          return Object.keys(item.license).length > 0;
        });
        if (index === -1) {
          updatedComponentList[currentIndex].title_license = '';
        } else {
          const new_version = Object.keys(checkedData[index].license)[0];
          updatedComponentList[currentIndex].title_license = checkedData[index].license[new_version];
        }
      } else {
        updatedComponentList[currentIndex].title_license = licenseData[0].license[component_version];
      }

      const securityData = securityResponse.response;
      updatedComponentList[currentIndex].securities = securityData[0].security_code;

      const homepageData = homepageResponse.response;
      updatedComponentList[currentIndex].homepage = homepageData.length > 0 ? homepageData[0].homepage : '';
    } catch (error) {
      console.error('Error fetching component details:', error);
    } finally {
      this.setState({ componentList: updatedComponentList });
    }
  };

  updateStateAndValidation = (id, newState) => {
    this.setState(newState, () => {
      this.changeValidation(id);
    });
  };

  updateComponentName = (componentList, index, value) => {
    return Update(componentList, {
      [index]: {
        component_name: { $set: value },
      },
    });
  };

  updateComponentListFields = (componentList, index, name) => {
    return Update(componentList, {
      [index]: {
        component_name: { $set: name },
        component_version: { $set: '' },
        title_license: { $set: '' },
        securities: { $set: [] },
        homepage: { $set: '' },
      },
    });
  };

  resetComponentFields = (componentList, index) => {
    return Update(componentList, {
      [index]: {
        component_version: { $set: '' },
        title_license: { $set: '' },
        securities: { $set: [] },
        homepage: { $set: '' },
      },
    });
  };

  onDragEnd = (result) => {
    const { source, destination } = result;
    const { isChange, componentList } = this.state;

    if (!result.destination) {
      return null;
    }

    if (
      destination.droppableId === source.droppableId
      && destination.index === source.index
    ) {
      return null;
    }

    const items = this.reorder(componentList, source.index, destination.index);

    if (isChange) {
      return this.setState({
        componentList: items,
      });
    }
    this.setState({
      isChange: true,
      componentList: items,
    });
  };

  getItemStyle = (isDragging, draggableStyle) => {
    return {
      background: isDragging && '#fae7ff',
      ...draggableStyle,
    };
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return this.resetDisplayPositions(result);
  };

  resetDisplayPositions = (list) => {
    const resetList = list.map((item, index) => {
      const slide = item;
      slide.displayPosition = index + 1;
      return slide;
    });
    return resetList;
  };

  validateForm = (component) => {
    const { translate } = this.props;
    const validations = [
      {
        key: 'component_name',
        message: 'modal.message.required_component_name',
      },
      {
        key: 'component_version',
        message: 'modal.message.required_component_version',
      },
      { key: 'title_license', message: 'modal.message.required_title_license' },
    ];

    const failedValidation = validations.find((validation) => {
      return component[validation.key] === '';
    });

    if (failedValidation) {
      this.setState({
        errorMessage: translate(failedValidation.message),
      });
      return false;
    }
    return true;
  };

  searchComponentName = (searchKeyword, dataType) => {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchPolicyComponent({
        search: newText,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        if (newText !== '' && data.indexOf(newText) === -1) {
          const newComponent = {
            id: 'exact',
            name: newText,
            data_type: dataType,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  searchComponentVersion = (searchKeyword, dataType, componentName) => {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchPolicyVersion({
        search: newText,
        component: componentName,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        if (newText !== '' && data.indexOf(newText) === -1) {
          const newComponent = {
            id: 'exact',
            name: newText,
            data_type: dataType,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  searchComponentLicense = (searchKeyword, dataType) => {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchPolicyLicense({
        search: newText,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        if (newText !== '' && data.indexOf(newText) === -1) {
          const newComponent = {
            id: 'exact',
            name: newText,
            data_type: dataType,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  searchComponentLicenses = async (name, version, id) => {
    const { titleLicenseLoadingIndex } = this.state;
    const obj = {
      component_list: [{ component_name: name, component_version: version }],
    };
    try {
      const res = await api.searchComponentLicenses(obj);
      const data = res.response;
      if (
        (version !== '' && Object.keys(data[0].license).length !== 0)
        || version === ''
      ) {
        const filteredData = titleLicenseLoadingIndex.filter((item) => {
          return item !== `title_license_${id}`;
        });
        this.setState({
          titleLicenseLoadingIndex: filteredData,
        });
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  searchComponentSecurities = async (name, version, id) => {
    const { securitiesLoadingIndex } = this.state;
    const obj = {
      component_list: [{ component_name: name, component_version: version }],
    };
    try {
      const res = await api.searchComponentSecurities(obj);
      const filteredData = securitiesLoadingIndex.filter((item) => {
        return item !== `securities_${id}`;
      });

      this.setState({
        securitiesLoadingIndex: filteredData,
      });
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  buildHomepageFromComponent = async (component_name, current_id) => {
    const { homepageLoadingIndex } = this.state;
    const obj = {
      component_list: [component_name],
    };

    try {
      const res = await api.buildHomepageFromComponent(obj);
      const filteredData = homepageLoadingIndex.filter((item) => {
        return item !== `homepage_${current_id}`;
      });
      this.setState({
        homepageLoadingIndex: filteredData,
      });

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  searchHomepage = async (searchKeyword, dataType) => {
    const { limit, currentId } = this.state;
    const obj = {
      search: searchKeyword,
      limit,
    };
    try {
      const res = await api.searchPolicyHomepage(obj);
      const data = res.response;
      const newData = data.map((item, index) => {
        return {
          id: index,
          name: item,
          data_type: dataType,
        };
      });

      if (searchKeyword !== '' && data.indexOf(searchKeyword) === -1) {
        const newComponent = {
          id: 'exact',
          name: searchKeyword,
          data_type: dataType,
        };
        newData.unshift(newComponent);
      }

      this.setState({
        activeIndex: `${dataType}_${currentId}`,
        resultList: newData,
      });
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  textValidation = (type, string) => {
    /** 숫자 알파벳 ~@^-_+=. 입력 가능 */
    let retValue = true;
    const character = /^[a-zA-Z0-9@\s~^+=._-]+$/;
    //~@^-_+=.-

    if (type === 'component_name' || type === 'component_version') {
      if (!string.match(character)) {
        retValue = false;
        return retValue;
      }
    }
    return retValue;
  };

  changeValidation = (id) => {
    const {
      componentList,
      revertList,
      sumData,
      isAppliyNextScan,
      coverage,
      comment,
    } = this.state;

    if (componentList.length !== revertList.length) {
      return this.setState({ isChange: true });
    }

    if (
      typeof sumData.is_applied === 'boolean'
      && typeof isAppliyNextScan === 'boolean'
    ) {
      if (sumData.is_applied !== isAppliyNextScan) {
        return this.setState({ isChange: true });
      }
    }

    if (sumData.coverage) {
      if (sumData.coverage !== coverage) {
        return this.setState({ isChange: true });
      }
    }

    if (sumData.comment) {
      if (sumData.comment !== comment) {
        return this.setState({ isChange: true });
      }
    }

    if (id) {
      const findCurrentIndex = componentList.findIndex((item) => {
        return item.id === id;
      });
      const findLegacyIndex = revertList.findIndex((item) => {
        return item.id === id;
      });

      if (
        findCurrentIndex === -1
        || findLegacyIndex === -1
        || findCurrentIndex !== findLegacyIndex
        || componentList[findCurrentIndex].component_name
          !== revertList[findLegacyIndex].component_name
        || componentList[findCurrentIndex].component_version
          !== revertList[findLegacyIndex].component_version
        || componentList[findCurrentIndex].title_license
          !== revertList[findLegacyIndex].title_license
        || componentList[findCurrentIndex].homepage
          !== revertList[findLegacyIndex].homepage
      ) {
        return this.setState({ isChange: true });
      }
    }

    return this.setState({ isChange: false });
  };

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal();
  };

  closeCVEModal = () => {
    this.setState({
      isOpenCVE: false,
    });
  };

  renderSaveBtn = () => {
    const { location, translate } = this.props;
    const path = location.pathname ? location.pathname : location;
    if (path.indexOf('settings') !== -1) {
      return (
        <a
          className="button save_button"
          style={{ cursor: 'pointer' }}
          onClick={this.handleSaveBySetting}
          onKeyUp={this.handleSaveBySetting}
        >
          {translate('modal.button.save')}
        </a>
      );
    }
    return (
      <a
        className="button save_button"
        style={{ cursor: 'pointer' }}
        onClick={this.handleSave}
        onKeyUp={this.handleSave}
      >
        {translate('modal.button.save')}
      </a>
    );
  };

  renderSecurityRow = (row, id) => {
    const { componentList, securitiesLoadingIndex } = this.state;
    const findCurrentIndex = componentList.findIndex((item) => {
      return item.id === id;
    });

    if (securitiesLoadingIndex.indexOf(`securities_${id}`) !== -1) {
      return (
        <div className="hover_area loader_wrap">
          <Table className="sub_table">
            <Table.Body>
              <Table.Row>
                <Table.Cell className="red">0</Table.Cell>
                <Table.Cell className="orange">0</Table.Cell>
                <Table.Cell className="cheese">0</Table.Cell>
                <Table.Cell className="yellow">0</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <Loader className="custom_loader" inline />
        </div>
      );
    }

    let medium = 0;
    let high = 0;
    let critical = 0;
    let low = 0;

    row.forEach((item) => {
      if (item.risk === 'medium') {
        medium += 1;
      } else if (item.risk === 'critical') {
        critical += 1;
      } else if (item.risk === 'high') {
        high += 1;
      } else if (item.risk === 'low') {
        low += 1;
      }
    });
    const security = {
      medium,
      high,
      critical,
      low,
    };

    const customIds = [];

    while (customIds.length < row.length) {
      const r = uuidv4();
      customIds.push(r);
    }

    const newData = row.map((o, index) => {
      return {
        id: customIds[index],
        code: o.code,
        risk: o.risk,
        disabled: true,
      };
    });

    return (
      <div
        className="hover_area"
        onClick={() => {
          return this.handleCVEModalChange(newData, findCurrentIndex);
        }}
        onKeyUp={() => {
          return this.handleCVEModalChange(newData, findCurrentIndex);
        }}
      >
        <Table className="sub_table">
          <Table.Body>
            <Table.Row>
              <Table.Cell className="red">{security.critical}</Table.Cell>
              <Table.Cell className="orange">{security.high}</Table.Cell>
              <Table.Cell className="cheese">{security.medium}</Table.Cell>
              <Table.Cell className="yellow">{security.low}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  };

  render() {
    const {
      componentList,
      sumData,
      selectedRowIds,
      activeIndex,
      isChange,
      resultList,
      errorIndex,
      cveList,
      isOpenCVE,
      currentCVEIndex,
      allSelected,
      titleLicenseLoadingIndex,
      target,
      errorMessage,
      homepageLoadingIndex,
    } = this.state;

    const {
      translate, isOpenMEC, isLoaderMEC, location
    } = this.props;

    const path = location.pathname ? location.pathname : location;
    const isShowComponent = path.indexOf('settings') !== -1;

    const scan_options = [
      {
        key: 'project',
        text: translate('modal.title.scan_specific_project'),
        value: 'project',
      },
      {
        key: 'company',
        text: translate('modal.title.all_scans'),
        value: 'company',
      },
    ];

    const renderIndeterminate = () => {
      return (
        selectedRowIds.length > 0 && selectedRowIds.length < componentList.length
      );
    };

    const globalErrorClass = errorMessage !== '' ? 'show' : '';

    const tableHeader = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell className="icon" style={{ width: '5%' }}>
            <Checkbox
              checked={allSelected}
              indeterminate={renderIndeterminate()}
              onChange={this.handleCheckAllChange}
            />
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '20%' }}>
            {translate('list.title.component')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '15%' }}>
            {translate('list.title.component_version')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '15%' }}>
            {translate('list.title.title_license')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '15%' }}>
            {translate('list.title.homepage')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '25%' }}>
            {translate('list.title.security')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '5%' }} />
        </Table.Row>
      </Table.Header>
    );

    const tableRow = (entity, provided, snapshot) => {
      return (
        <Ref innerRef={provided.innerRef}>
          <Table.Row
            {...provided.draggableProps}
            style={this.getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <Table.Cell textAlign="center" style={{ width: '5%' }}>
              <Checkbox
                value={entity.id}
                checked={selectedRowIds.indexOf(entity.id) > -1}
                onChange={this.handleCheckChange}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '20%' }}
              className={cx('component_name', {
                visible: activeIndex === `component_name_${entity.id}`,
              })}
            >
              <Input
                type="text"
                error={errorIndex.indexOf(`component_name_${entity.id}`) !== -1}
                value={entity.component_name}
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'component_name',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'component_name',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnName(entity.id);
                }}
                onMouseOver={this.handleMouseOver}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `component_name_${entity.id}`}
                translate={translate}
                Ref={this.resultsRef}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '15%' }}
              className={cx('component_version', {
                visible: activeIndex === `component_version_${entity.id}`,
              })}
            >
              <Input
                type="text"
                error={
                  errorIndex.indexOf(`component_version_${entity.id}`) !== -1
                }
                value={entity.component_version}
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'component_version',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'component_version',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnVersion(entity.id);
                }}
                onMouseOver={this.handleMouseOver}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `component_version_${entity.id}`}
                translate={translate}
                Ref={this.resultsRef}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '15%' }}
              className={cx('title_license', {
                visible: activeIndex === `title_license_${entity.id}`,
              })}
            >
              <Input
                type="text"
                loading={
                  titleLicenseLoadingIndex.indexOf(
                    `title_license_${entity.id}`
                  ) !== -1
                }
                disabled={
                  titleLicenseLoadingIndex.indexOf(
                    `title_license_${entity.id}`
                  ) !== -1
                }
                error={errorIndex.indexOf(`title_license_${entity.id}`) !== -1}
                value={entity.title_license}
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'title_license',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'title_license',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnLicense(entity.id);
                }}
                onMouseOver={this.handleMouseOver}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `title_license_${entity.id}`}
                translate={translate}
                Ref={this.resultsRef}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '15%' }}
              className={cx('homepage', {
                visible: activeIndex === `homepage_${entity.id}`,
              })}
            >
              <Input
                type="text"
                value={entity.homepage || ''}
                loading={
                  homepageLoadingIndex.indexOf(`homepage_${entity.id}`) !== -1
                }
                disabled={
                  homepageLoadingIndex.indexOf(`homepage_${entity.id}`) !== -1
                }
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'homepage',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'homepage',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnHomepage(entity.id);
                }}
                onMouseOver={this.handleMouseOver}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `homepage_${entity.id}`}
                translate={translate}
                Ref={this.resultsRef}
              />
            </Table.Cell>
            <Table.Cell style={{ width: '25%' }}>
              {this.renderSecurityRow(entity.securities, entity.id)}
            </Table.Cell>
            <Table.Cell style={{ width: '5%' }} textAlign="center">
              <a
                className="drager_button"
                style={{ cursor: 'grab' }}
                {...provided.dragHandleProps}
              >
                <img src={dragbarImg} alt="" />
              </a>
            </Table.Cell>
          </Table.Row>
        </Ref>
      );
    };

    return (
      <Modal open={isOpenMEC} onClose={this.closeModal}>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="setting_popup_wrap">
            <div
              className="setting_popup default_popup edit_detail"
              ref={this.modalRef}
            >
              <div className="header_wrap">
                <Header as="h3">
                  <Icon name="puzzle piece" />
                  {sumData.component_name}
                </Header>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="header_wrap_error">
                <div className={`error ${globalErrorClass}`}>
                  {errorMessage}
                </div>
              </div>
              <div className="header_wrap_util between">
                {sumData.versionList && (
                  <div className="util_wrap_left">
                    <Header as="h5">
                      <Icon name="code branch" />
                      <Header.Content>
                        {translate('list.title.component_version')}
                        <Dropdown
                          className="util_dropdown"
                          inline
                          options={sumData.versionList}
                          value={target}
                          disabled={isShowComponent}
                          onChange={this.handleTargetOptionChange}
                        />
                      </Header.Content>
                    </Header>
                  </div>
                )}
                <div className="util_wrap_right">
                  <div className="apply_scan">
                    {typeof sumData.has_global_permission === 'boolean' && sumData.has_global_permission ? (
                      <Checkbox
                        label={translate('modal.message.apply_next_scan')}
                        checked={sumData.is_applied}
                        onChange={this.handleApplyNextScanChange}
                      />
                    ) : null}
                  </div>
                  {(isShowComponent || sumData.is_applied) && (
                    <div className="apply_scan_dropdown_wrap">
                      <Dropdown
                        options={scan_options}
                        value={sumData.coverage}
                        onChange={this.handleOptionChange}
                      />
                    </div>
                  )}
                  <div className="button_wrap">
                    {componentList.length !== 0 && selectedRowIds.length !== 0 ? (
                      <a
                        className="delete_button util_button"
                        onClick={this.handleDeleteRow}
                        onKeyUp={this.handleDeleteRow}
                      >
                        {translate('modal.button.delete')}
                      </a>
                    ) : (
                      <a
                        className="delete_button util_button"
                        style={{
                          pointerEvents: 'none',
                          cursor: 'default',
                          opacity: '.45',
                        }}
                      >
                        {translate('modal.button.delete')}
                      </a>
                    )}
                    <a
                      className="add_button util_button"
                      onClick={this.handleAddRow}
                      onKeyUp={this.handleAddRow}
                    >
                      {translate('modal.button.add')}
                    </a>
                  </div>
                </div>
              </div>
              {!isLoaderMEC && sumData.component_name ? (
                <div>
                  <Table attached="top" fixed>
                    {tableHeader}
                  </Table>
                  <Scrollbars
                    renderTrackHorizontal={() => {
                      return <div />;
                    }}
                    renderThumbHorizontal={() => {
                      return <div />;
                    }}
                    autoHeight
                    autoHeightMin={430}
                    autoHeightMax={430}
                  >
                    <Table attached fixed>
                      <Droppable droppableId="tableBody">
                        {(provided) => {
                          return (
                            <Ref innerRef={provided.innerRef}>
                              <Table.Body {...provided.droppableProps}>
                                {componentList.map((entity, index) => {
                                  return (
                                    <Draggable
                                      draggableId={entity.id.toString()}
                                      index={index}
                                      key={entity.id}
                                      isDragDisabled={activeIndex !== ''}
                                    >
                                      {(
                                        draggableProvided,
                                        draggableSnapshot
                                      ) => {
                                        const child = tableRow(
                                          entity,
                                          draggableProvided,
                                          draggableSnapshot
                                        );
                                        if (draggableSnapshot.isDragging) {
                                          return (
                                            <Portal
                                              open={
                                                draggableSnapshot.isDragging
                                              }
                                            >
                                              <Table
                                                className="portal_table"
                                                attached
                                                fixed
                                                celled
                                              >
                                                <Table.Body>
                                                  {tableRow(
                                                    entity,
                                                    draggableProvided,
                                                    draggableSnapshot
                                                  )}
                                                </Table.Body>
                                              </Table>
                                            </Portal>
                                          );
                                        }
                                        return child;
                                      }}
                                    </Draggable>
                                  );
                                })}
                                {provided.placeholder}
                              </Table.Body>
                            </Ref>
                          );
                        }}
                      </Droppable>
                    </Table>
                  </Scrollbars>
                  <ModalDescription className="edit_detail_description">
                    <div className="title">
                      {translate('modal.title.comment')}
                    </div>
                    <TextArea
                      disabled={!sumData.is_applied && !isShowComponent}
                      value={sumData.comment}
                      onChange={this.handleTextAreaChange}
                    />
                  </ModalDescription>
                </div>
              ) : (
                <ClarLoader />
              )}
              <div className="setting_popup_button_wrap">
                <a
                  className="button cencel_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  {translate('modal.button.cancel')}
                </a>
                {isChange ? (
                  this.renderSaveBtn()
                ) : (
                  <a
                    className="button save_button"
                    style={{
                      pointerEvents: 'none',
                      cursor: 'default',
                      opacity: '.45',
                    }}
                  >
                    {translate('modal.button.save')}
                  </a>
                )}
              </div>
            </div>
          </div>
        </DragDropContext>
        <EditCveCodeModal
          isOpenCVE={isOpenCVE}
          cveList={cveList}
          translate={translate}
          updateCallback={this.handleCVEDataChange}
          closeModal={this.closeCVEModal}
          currentCVEIndex={currentCVEIndex}
        />
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(EditComponentModal)));
